import { trim } from '../../../../utils/tools'

const HISTORY_NAME = 'HOMEPAGE/SEARCH/HISTORY'
export const enum HISTORY_TYPE {
    SPECIAL = 'special',
    NORMAL = 'normal'
}

// 初始取历史记录值
export function getHistoryFromStorage() {
    let history
    const searchHistoryFromStoarge = []
    if (window.localStorage.getItem(HISTORY_NAME) && window.localStorage.getItem(HISTORY_NAME) !== null) {
        history = JSON.parse(window.localStorage.getItem(HISTORY_NAME))
    }

    if (history) {
        if (history.length > 1) {
            for (const [index, value] of Object.entries(history)) {
                searchHistoryFromStoarge.push(value)
            }
            return searchHistoryFromStoarge
        } else {
            searchHistoryFromStoarge.push(history[0])
            return searchHistoryFromStoarge
        }
    } else {
        return null
    }
}

export function insertValueToStorage(value: string, histotyType: HISTORY_TYPE, url: string = `${value}`) {
    const UserTypeValue = trim(value)
    let getHistoryArr = getHistoryFromStorage()

    if (getHistoryArr !== null) {
        for (const [index, item] of Object.entries(getHistoryArr)) {
            if (UserTypeValue === item.name) {
                const tempObj = {
                    name: UserTypeValue,
                    type: histotyType,
                    url
                }
                getHistoryArr.splice(Number(index), 1)
                getHistoryArr.unshift(tempObj)
                window.localStorage.setItem(HISTORY_NAME, JSON.stringify(getHistoryArr))
                return getHistoryArr.length > 8 ? getHistoryArr.splice(0, 8) : getHistoryArr
            }
       }
    } else {
        getHistoryArr = []
    }

    const tempArr = []
    tempArr.push({
        name: UserTypeValue,
        type: histotyType,
        url
    })

    const insertArr = tempArr.concat(getHistoryArr)
    window.localStorage.setItem(HISTORY_NAME, JSON.stringify(insertArr))
    return insertArr.length > 8 ? insertArr.splice(0, 8) : insertArr
}



// WEBPACK FOOTER //
// ./src/views/SearchResult/components/SearchInput/historyStorage.ts